import React from 'react';
import i18n from '../../../translate/i18n';
import Select from '../../Form/Select';
import Input from '../../Form/Input';
import Radio from '../../Form/Radio'
import FormEntrevista from '../FormEntrevista'
import UploadFiles from 'components/Form/UploadFiles';


interface TypeProps {
  data: any,
  handleSelectChange: Function,
  handleInputChange: Function,
}

interface TypeSelectData {
  _id: string,
  name: string,
}

export default function Entrevista({ data, handleSelectChange, handleInputChange }: TypeProps) {


  return (

    <div className='container-box'>
      <h5>{i18n.t<string>('edit.interviews')}</h5>
      <hr />
      <form>
        {data?.tipoSindicancia === 'remota' &&
          <div >
            <Input
              name="profissaoSegurado"
              label="Profissão do segurado"
              type="text"
              placeholder={'Profissão do segurado'}
              data={data?.profissaoSegurado || ''}
              setData={handleInputChange}
            />
            <Radio
              title="Local do pernoite"
              data={[
                { _id: 'Mesmo da apólice', name: 'Mesmo da apólice' },
                { _id: 'Diferente da apólice', name: 'Diferente da apólice' },
              ]}
              value={data?.localPernoite || ''}
              setSelected={(value: string) => { handleSelectChange('localPernoite', value) }}
            />
            <Radio
              title="Segurado é único condutor"
              data={[
                { _id: 'sim', name: 'Sim' },
                { _id: 'nao', name: 'Não' },
              ]}
              value={data?.unicoCondutor || ''}
              setSelected={(value: string) => { handleSelectChange('unicoCondutor', value) }}
            />
            <Radio
              title="Residência possui pessoas entre 18 e 25 anos"
              data={[
                { _id: 'sim', name: 'Sim' },
                { _id: 'nao', name: 'Não' },
              ]}
              value={data?.residIdade || ''}
              setSelected={(value: string) => { handleSelectChange('residIdade', value) }}
            />
            <Radio
              title="Residência possui pessoas entre 18 e 25 anos que utilizam o veículo"
              data={[
                { _id: 'sim', name: 'Sim' },
                { _id: 'nao', name: 'Não' },
              ]}
              value={data?.residIdadeVeiculo || ''}
              setSelected={(value: string) => { handleSelectChange('residIdadeVeiculo', value) }}
            />
            <Select
              title="Condutor principal"
              data={[
                { _id: 'filho', name: 'Filho (a)' },
                { _id: 'conjuge', name: 'Esposa (o)' },
                { _id: 'pai', name: 'Pai' },
                { _id: 'mae', name: 'Mãe' },
                { _id: 'outros', name: 'Outros' },
              ]}
              value={data?.condutorPrincipal || ''}
              setSelected={(value: string) => { handleSelectChange('condutorPrincipal', value) }}
            />

            <Radio
              title="CPF do condutor cadastrado em aplicativo"
              data={[
                { _id: 'sim', name: 'Sim' },
                { _id: 'nao', name: 'Não' },
              ]}
              value={data?.possuiCadastroAplicativo || ''}
              setSelected={(value: string) => { handleSelectChange('possuiCadastroAplicativo', value) }}
            />
            <Select
              title="Segurado é motorista de aplicativo"
              data={[
                { _id: 'uber', name: 'Uber' },
                { _id: '99', name: '99' },
                { _id: 'cabify', name: 'Cabify' },
                { _id: 'in drive', name: 'In drive' },
                { _id: 'wappa', name: 'Wappa' },
                { _id: 'nao', name: 'Não' },
              ]}
              value={data?.cadastroAplicativo || ''}
              setSelected={(value: string) => { handleSelectChange('cadastroAplicativo', value) }}
            />

            <Radio
              title="No dia do evento estava com passageiros no veículo"
              data={[
                { _id: 'sim', name: 'Sim' },
                { _id: 'nao', name: 'Não' },
              ]}
              value={data?.haviaPassageiro || ''}
              setSelected={(value: string) => { handleSelectChange('haviaPassageiro', value) }}
            />

            <Radio
              title="Houve endosso de uso particular para comercial"
              data={[
                { _id: 'sim', name: 'Sim' },
                { _id: 'nao', name: 'Não' },
              ]}
              value={data?.endossoParticularComercial || ''}
              setSelected={(value: string) => { handleSelectChange('endossoParticularComercial', value) }}
            />
            <Radio
              title="Evento antes ou depois do endosso"
              data={[
                { _id: 'antes', name: 'Antes' },
                { _id: 'depois', name: 'Depois' },
              ]}
              value={data?.endossoAntesDepois || ''}
              setSelected={(value: string) => { handleSelectChange('endossoAntesDepois', value) }}
            />
            <Radio
              title="Extrato das corridas corresponde ao período de vigência da apólice"
              data={[
                { _id: 'sim', name: 'Sim' },
                { _id: 'nao', name: 'Não' },
              ]}
              value={data?.extratoCorrida || ''}
              setSelected={(value: string) => { handleSelectChange('extratoCorrida', value) }}
            />
            <Select
              title="Média de Km rodado por dia/semana"
              data={[
                { _id: '50 - 100', name: '50 - 100' },
                { _id: '101 - 200', name: '101 - 200 ' },
                { _id: '201 - 300', name: '201 - 300 ' },
                { _id: '301 - 400', name: '301 - 400 ' },
                { _id: '401 - 1000', name: '401 - 1000 ' },

              ]}
              value={data?.mediaKmDiaSemana || ''}
              setSelected={(value: string) => { handleSelectChange('mediaKmDiaSemana', value) }}
            />

            <Input
              name="kmAtual"
              label="Quilometragem atual do veículo"
              type="number"
              placeholder={'Quilometragem atual do veículo'}
              data={data?.kmAtual || ''}
              setData={handleInputChange}
            />
          </div>
        }

        <div >
          <h4>Entrevista com o Segurado</h4>
          <Radio
            title="Entrevista com o Segurado"
            data={[
              { _id: 'sim', name: 'Sim' },
              { _id: 'nao', name: 'Não' },
            ]}
            value={data?.segConvivioComercial || ''}
            setSelected={(value: string) => { handleSelectChange('segConvivioComercial', value) }}
          />
          {data?.segConvivioComercial === 'sim' && (
            <FormEntrevista
              handleSelectChange={handleSelectChange}
              handleInputChange={handleInputChange}
              nameCPF={"segConvivioComercialCPF"}
              valueCPF={data?.segConvivioComercialCPF}
              nameNome={"segConvivioComercialNome"}
              valueNome={data?.segConvivioComercialNome}
              nameUF={"segConvivioComercialUF"}
              valueUF={data?.segConvivioComercialUF}
              nameCidade={"segConvivioComercialCidade"}
              valueCidade={data?.segConvivioComercialCidade}
              nameRelato={"segConvivioComercialRel"}
              valueRelato={data?.segConvivioComercialRel}
            />
          )}
        </div>

        <div >
          <h4>Entrevista com Envolvido</h4>
          <Radio
            title="Entrevista com Envolvido"
            data={[
              { _id: 'sim', name: 'Sim' },
              { _id: 'nao', name: 'Não' },
            ]}
            value={data?.segConvivioResidencial || ''}
            setSelected={(value: string) => { handleSelectChange('segConvivioResidencial', value) }}
          />
          {data?.segConvivioResidencial === 'sim' && (
            <FormEntrevista
              handleSelectChange={handleSelectChange}
              handleInputChange={handleInputChange}
              nameCPF={"segConvivioResidencialCPF"}
              valueCPF={data?.segConvivioResidencialCPF}
              nameNome={"segConvivioResidencialNome"}
              valueNome={data?.segConvivioResidencialNome}
              nameUF={"segConvivioResidencialUF"}
              valueUF={data?.segConvivioResidencialUF}
              nameCidade={"segConvivioResidencialCidade"}
              valueCidade={data?.segConvivioResidencialCidade}
              nameRelato={"segConvivioResidencialRel"}
              valueRelato={data?.segConvivioResidencialRel}
            />
          )}
        </div>

        <div >
          <div className="field">
            <label className='checkbox'>
              <input
                type='checkbox'
                name='teceirosCheck'
                checked={data.listarTerceiros || false}
                onClick={({ target }: any) => { handleSelectChange('listarTerceiros', target.checked) }}
              />Listar terceiros
        </label>
          </div>
        </div>

        {data.listarTerceiros &&
          <>
            <div >
              <h4>Entrevista com o Terceiro</h4>
              <Radio
                title="Entrevista com o Terceiro"
                data={[
                  { _id: 'sim', name: 'Sim' },
                  { _id: 'nao', name: 'Não' },
                ]}
                value={data?.terConvivioComercial || ''}
                setSelected={(value: string) => { handleSelectChange('terConvivioComercial', value) }}
              />

              {data?.terConvivioComercial === 'sim' && (
                <FormEntrevista
                  handleSelectChange={handleSelectChange}
                  handleInputChange={handleInputChange}
                  nameCPF={"terConvivioComercialCPF"}
                  valueCPF={data?.terConvivioComercialCPF}
                  nameNome={"terConvivioComercialNome"}
                  valueNome={data?.terConvivioComercialNome}
                  nameUF={"terConvivioComercialUF"}
                  valueUF={data?.terConvivioComercialUF}
                  nameCidade={"terConvivioComercialCidade"}
                  valueCidade={data?.terConvivioComercialCidade}
                  nameRelato={"terConvivioComercialRel"}
                  valueRelato={data?.terConvivioComercialRel}
                />
              )}
            </div>

            <div >
              <h4>Entrevista com Envolvido (terceiro)</h4>
              <Radio
                title="Entrevista com Envolvido (terceiro)"
                data={[
                  { _id: 'sim', name: 'Sim' },
                  { _id: 'nao', name: 'Não' },
                ]}
                value={data?.terConvivioResidencial || ''}
                setSelected={
                  (value: string) => {
                    handleSelectChange('terConvivioResidencial', value)
                  }
                }
              />
              {data?.terConvivioResidencial === 'sim' && (

                <FormEntrevista
                  handleSelectChange={handleSelectChange}
                  handleInputChange={handleInputChange}
                  nameCPF={"terConvivioResidencialCPF"}
                  valueCPF={data?.terConvivioResidencialCPF}
                  nameNome={"terConvivioResidencialNome"}
                  valueNome={data?.terConvivioResidencialNome}
                  nameUF={"terConvivioResidencialUF"}
                  valueUF={data?.terConvivioResidencialUF}
                  nameCidade={"terConvivioResidencialCidade"}
                  valueCidade={data?.terConvivioResidencialCidade}
                  nameRelato={"terConvivioResidencialRel"}
                  valueRelato={data?.terConvivioResidencialRel}
                />
              )}
            </div>

          </>
        }
        <div >
          {
            data.id &&
            <UploadFiles
              name="images"
              label="Inserir imagens e/ou documentos dos tipos: PNG, JPEG, JPG e PDF"
              osId={data?.id}
              etapa={'entrevista'}
            />
          }
        </div>

      </form>
    </div>
  )
}
